import React from 'react';
import { Link } from 'react-router-dom';

import AuthCardLayout from 'layouts/AuthCardLayout';
import LoginFormCuotas from '../LoginFormCuotas';

const LoginCuotas = () => {
  return (
    <AuthCardLayout
      leftSideContent={
        <p className="text-white">
          Crear Cuenta
          <br />
          <Link
            className="text-white text-decoration-underline"
            to="/authentication/card/register"
          >
            Iniciar!
          </Link>
        </p>
      }
    >
      <h3>Iniciar sesión</h3>
      <LoginFormCuotas layout="card" hasLabel />
    </AuthCardLayout>
  );
};

export default LoginCuotas;